import { authStore } from '@/stores/auth';
import { useStore } from '@nanostores/react';
import Cookies from 'universal-cookie';
import { trackEvent } from './api';
import { useCurrentWorkspace } from '@/context/current-workspace';

/**
 * This is intended to be a very lite version of track functionality in Journeys UI.
 */

export function getGoogleAnalyticsClientID() {
  return window.ga?.getAll?.()[0]?.get('clientId');
}

export function getSegmentAnonymousId() {
  const cookies = new Cookies();
  const id = cookies.get('ajs_anonymous_id');
  if (id != null) {
    return id;
  }

  // Segment JSON.stringifies a string before saving it as a cookie,
  // so it adds extra quotes around that string. We try to parse it,
  // and if it succeeds, that will return the string, otherwise we
  // just sent the value as it is.
  try {
    return JSON.parse(id);
  } catch {
    return id;
  }
}

function getAnalyticsMetaProperties() {
  return {
    path: window.location.pathname,
    referrer: document.referrer,
    search: window.location.search,
    title: document.title,
    url: window.location.href,
    user_agent: navigator.userAgent,
    segment_anonymous_id: getSegmentAnonymousId(),
    google_client_id: getGoogleAnalyticsClientID(),
  };
}

export const useTrackEvent = () => {
  const auth = useStore(authStore);
  const workspace = useCurrentWorkspace();
  const isMasq = auth.account?.is_masq ?? false;

  return async (event: string, properties: Record<string, unknown> = {}) => {
    const metaProperties = getAnalyticsMetaProperties();
    const eventProperties = {
      ...metaProperties,
      ...properties,
    };

    return new Promise<void>((resolve) => {
      if (isMasq || workspace == null) {
        return resolve();
      }

      // we resolve both on success and failure to avoid noise/blocking the app since users should not be concerned about this
      trackEvent(event, eventProperties, workspace.id)
        .then(() => resolve())
        .catch(() => resolve());
    });
  };
};
